import * as React from 'react';

import { cn } from '../../lib/utils.ts';
import { Checkbox } from './checkbox.tsx';

interface LabeledCheckboxProps {
  /** `'indeterminate'` draws the partial-selection dash, for a "select all" over a mixed list. */
  checked: boolean | 'indeterminate';
  onCheckedChange: (checked: boolean) => void;
  label: React.ReactNode;
  disabled?: boolean;
  id?: string;
  className?: string;
}

/**
 * Clean replacement for MUI's <FormControlLabel control={<Checkbox/>} /> using the
 * shared Radix checkbox. Keeps a simple checked/onCheckedChange/label/disabled API.
 */
const LabeledCheckbox = ({ checked, onCheckedChange, label, disabled, id, className }: LabeledCheckboxProps) => (
  <label
    className={cn(
      'inline-flex items-center gap-2 text-base text-gray-800 select-none py-2',
      disabled ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer',
      className
    )}
  >
    <span className="px-1 shrink-0">
      <Checkbox id={id} checked={checked} onCheckedChange={(v) => onCheckedChange(v === true)} disabled={disabled} />
    </span>
    <span>{label}</span>
  </label>
);

export { LabeledCheckbox };
